import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h6>{`現職`}</h6>
    <p>{`Red Hat 解決方案架構師，主要負責微服務設計開發及整合、企業容器平台應用、DevOps 建置。`}</p>
    <h6>{`其他經驗`}</h6>
    <p>{`金融相關產業資訊專案單位及資訊開發單位，專攻於金融產業業務中台設計。`}</p>
    <h6>{`核心思想`}</h6>
    <p>{`業務導向。因擁有業務及 IT 雙重背景，致力於於推廣由業務行為看系統設計的方法論。業務和 IT 是一個相輔相成的二元體，由技術解決業務問題，由業務複雜度引進新的技術可能。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      